import { Component, inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { LoaderService } from 'src/app/component/loader-spinner/loader.service';
import { Lang, LANG_CONFIG_MANUALES } from 'src/app/models';
import { DatabaseService } from 'src/app/servicios/database/database.service';

interface LanguageConfig {
  code: Lang;
  label: string;
  control: FormControl;
}

@Component({
  selector: 'app-subir-manuales',
  templateUrl: './subir-manuales.component.html',
  styleUrls: ['./subir-manuales.component.scss'],
  standalone: false,
})
export class SubirManualesComponent implements OnInit {
  private databaseService = inject(DatabaseService);
  private dialogRef = inject(MatDialogRef<SubirManualesComponent>);
  private _loaderService = inject(LoaderService);

  public files!: FormData;

  languages: LanguageConfig[] = LANG_CONFIG_MANUALES.map((lang) => ({
    ...lang,
    control: new FormControl(''),
  }));

  ngOnInit(): void {
    this.files = new FormData();
  }

  /**
   * Maneja la seleccion de un archivo para un idioma determinado
   * @param event - evento de seleccion de archivo
   * @param lang - configuracion del idioma
   * @returns
   */
  onSubmit(event: any, lang: LanguageConfig) {
    const file: File = event.target.files[0];
    if (!file) return;

    this.files.set(lang.code, file);
    lang.control.setValue(file.name);
  }

  /**
   * Confirma la subida de los manuales seleccionados
   */
  onConfirm() {
    const fechaActual = moment().format('yyyyMMDDHHmmss');
    this.files.append('filename', fechaActual);
    this._loaderService.showSpinner();

    this.databaseService.subirManuales(this.files).subscribe(() => {
      this.files = new FormData();
      this._loaderService.hideSpinner();
      this.dialogRef.close();
    });
  }

  /**
   * Verifica si no se ha seleccionado ningun archivo
   */
  get isDisabled(): boolean {
    return this.languages.every((l) => !l.control.value);
  }
}
